import React, {VoidFunctionComponent} from 'react';
import {useIntl} from 'react-intl';

import ToggleSwitch from '../../../toggle-switch/toggle-switch';
import {useFilters} from '../../../../../hooks/useFilters';

import {yearFilterEntries} from '../../../../../constants/filter';

import {YearFilterValues} from '../../../../../../../shared/types/filter';

import styles from '../filters.module.css';

const YearFilters: VoidFunctionComponent = () => {
  const {formatMessage} = useIntl();
  const {selectedYearFilterOptions, setSelectedYears} = useFilters();

  return (
    <ul className={styles.filterList}>
      {yearFilterEntries.map(yearFilterEntry => {
        const isYearBefore1945 =
          yearFilterEntry.value === YearFilterValues.before1945;

        const checked = selectedYearFilterOptions.includes(yearFilterEntry);

        return (
          <ToggleSwitch
            onChange={() => setSelectedYears(yearFilterEntry)}
            value={yearFilterEntry.value}
            key={yearFilterEntry.label}
            label={formatMessage({id: `${yearFilterEntry.label}`})}
            name="years"
            variant={isYearBefore1945 ? 'secondary' : 'primary'}
            checked={checked}
          />
        );
      })}
    </ul>
  );
};
export default YearFilters;
